/* Ott-common */
import { PROVIDER } from '@dtvgo/backend-service/normalize';

/* Utils */
import { generateEntityActionTypes } from '../utils/generators/actionTypeGenerators';

const ENTITY_NAME = 'CHANNELS';

export const FETCH_ALL_CHANNELS = `${ENTITY_NAME}/FETCH/ALL`;
export const FETCH_CHANNEL_SCHEDULES = {
  [PROVIDER.VRIO]: `${ENTITY_NAME}/FETCH/SCHEDULES/${PROVIDER.VRIO}`,
};
export const SCHEDULE_FETCH_CHANNEL_SCHEDULES = `${ENTITY_NAME}/SCHEDULE_FETCH_SCHEDULES`;
export const FETCH_CHANNEL_SCHEDULES_BY_EVENT_TYPE = `${ENTITY_NAME}/FETCH_SCHEDULES_BY_EVENT_TYPE`;

export const CHANNEL_ENTITY_ACTION_TYPES = generateEntityActionTypes(ENTITY_NAME);
